export default __webpack_public_path__ + "static/media/kylian-mbappe.937f333d.jpg";